export default "__VITE_ASSET__cC7FeaPu__"